import React, { Suspense } from 'react';
import { Modal } from '@utex/ui-kit';
import { FormView } from '../Form';
import { Loader } from '../Loader';
import { useModalService } from '../../hooks/useModalService';

export const MainScreen: React.FC = () => {
  const { isOpened, closeImmediately } = useModalService();

  return (
    <Modal isOpen={isOpened} size={430} onRequestClose={closeImmediately} testId="conversion-modal">
      <Suspense fallback={<Loader />}>
        <FormView />
      </Suspense>
    </Modal>
  );
};
